/* Customization:
- Used custom button from @redturtle/volto-io-studio
TO DO: da rimuovere e sostituire con una customizzazione da config, da settare su volto-rt-blocks
*/

import React from 'react';
import { Button } from '@redturtle/volto-io-studio/components';
import { UniversalLink } from '@plone/volto/components';

const NumbersButton = ({ data }) => {
  return data.href_title && data.href?.length > 0 ? (
    <div className="number-link">
      <Button
        as={UniversalLink}
        item={data.href[0]}
        color="primary"
        wide
        padded
        noradius
      >
        {data.href_title}
      </Button>
    </div>
  ) : (
    <></>
  );
};

export default NumbersButton;
